import { useGenericSurvey } from "features/subscription-process/profiling-process/hooks/useGenericSurvey"
import { PossibleAnswer } from "features/subscription-process/profiling-process/types/interfaces"
import { FC, ReactNode, useMemo } from "react"

interface GenericSurveyCompactProps {
  survey?: Record<string, PossibleAnswer>
  title: string
  titleAside?: ReactNode
}

export const GenericSurveyCompact: FC<GenericSurveyCompactProps> = ({ survey, title, titleAside }) => {
  const { questionWithAnswers } = useGenericSurvey()
  const mappedSurvey = useMemo(() => questionWithAnswers(survey), [questionWithAnswers, survey])

  console.log(mappedSurvey)
  if (!mappedSurvey) {
    return <></>
  }

  return (
    <div className="bg-white rounded-xl shadow-lg overflow-hidden border">
      <div className="bg-gray-50/50 px-6 py-4 border-b flex items-center justify-between">
        <h3 className="text-lg font-semibold text-primary">{title}</h3>
        {titleAside && <div>{titleAside}</div>}
      </div>

      <div className="p-6 space-y-4">
        {mappedSurvey.flatMap((group) =>
          group.questions.map((item, index) => (
            <div
              key={`${group.title}-${index}`}
              className="relative p-5 rounded-lg border-l-4 bg-primary/5 border-l-primary/60 transition-all duration-200 hover:shadow-md hover:bg-primary/10"
            >
              <div className="flex items-start justify-between gap-4">
                {/* Question */}
                <div className="flex-1">
                  <label className="block font-medium text-gray-800 mb-3 leading-relaxed">
                    {item.question}
                  </label>

                  {/* Réponses */}
                  <div className="flex flex-wrap items-center gap-2">
                    {item.answers.map((answer: any, answerIndex: number) => (
                      <div
                        key={answerIndex}
                        className="inline-flex items-center px-3 py-1.5 rounded-full text-sm font-medium bg-primary/20 text-primary-dark border border-primary/30"
                      >
                        <span className="w-2 h-2 rounded-full mr-2 bg-primary"></span>
                        {typeof answer === 'boolean' 
                          ? (answer ? 'Oui' : 'Non')
                          : answer
                        }
                      </div>
                    ))}
                  </div>
                </div>

                {/* Icône */}
                <div className="w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 bg-primary/15 text-primary">
                  <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                </div>
              </div>
            </div>
          ))
        )}
      </div>

      {/* Footer informatif */}
      <div className="bg-gray-50/50 px-6 py-4 border-t border-gray-200/50">
        <p className="text-sm text-gray-600 flex items-center gap-2">
          <svg className="w-4 h-4 text-primary/60" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
          </svg>
          Résumé de vos réponses
        </p>
      </div>
    </div>
  )
}
